// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://use.typekit.net/las6vnw.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Hero_fonts-loaded__Anspl .Hero_gradientText__R1heV {
  font-family: "neuropol-nova", sans-serif !important;
}

.Hero_heroSection__T2p92 {
  position: relative;
  width: 100%;
  height: 90dvh;
  padding-top: 80px;
  overflow: hidden;
  background-color: #040404;
}

.Hero_heroWrap__HEldU {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 100;
  overflow: hidden;
}

.Hero_backgroundVideo__yrEow {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
}

.Hero_hero__II8BZ {
  position: relative;
  z-index: 1;
  text-align: center;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 24px;
  padding: 30px 20px;
}

.Hero_heroTitle__wx3\\+G {
  display: flex;
  justify-content: center;
  width: 100%;
  overflow: visible;
  position: relative;
  display: flex;
  align-items: center;
}


.Hero_heroTitle__wx3\\+G {
  font-size: 1.5rem;
  font-weight: 400;
  margin-bottom: 10px;
  line-height: 1.5;
}

.Hero_buttonsContainer__w9d7N {
  display: flex;
  justify-content: center;
  gap: 32px;
  position: relative;
  z-index: 2;
}

.Hero_heroButton__q3Zvu {
  margin: 0;  
}

.Hero_learnMore__FUrNz {
  display: flex;
  align-items: center;
  color: white;
  text-decoration: none;
}

.Hero_learnMoreButton__SK8eT {
  margin-right: 5px;
}

.Hero_icon__jyGut {
  font-size: 18px;
}

@media (max-width: 768px) {
  .Hero_gradientText__R1heV {
    font-size: 10rem;
  }
}

@media (max-width: 480px) {
  .Hero_gradientText__R1heV {
    font-size: 6rem;
  }
}

.Hero_heroWrap__HEldU::before {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 40%;  
  background: linear-gradient(to bottom, transparent, rgba(4, 4, 4, 1)); 
  z-index: 1;
  pointer-events: none;
}

.Hero_heroWrap__HEldU::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 0;  
}

.Hero_hero__II8BZ, .Hero_buttonsContainer__w9d7N {
  position: relative;
  z-index: 2;
}
`, "",{"version":3,"sources":["webpack://./src/pages/HomePage/Sections/Hero/Hero.module.css"],"names":[],"mappings":"AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;;AAGA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,qEAAqE;EACrE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ","sourcesContent":["@import url('https://use.typekit.net/las6vnw.css');\n\n.fonts-loaded .gradientText {\n  font-family: \"neuropol-nova\", sans-serif !important;\n}\n\n.heroSection {\n  position: relative;\n  width: 100%;\n  height: 90dvh;\n  padding-top: 80px;\n  overflow: hidden;\n  background-color: #040404;\n}\n\n.heroWrap {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  z-index: 100;\n  overflow: hidden;\n}\n\n.backgroundVideo {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  z-index: 0;\n}\n\n.hero {\n  position: relative;\n  z-index: 1;\n  text-align: center;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 24px;\n  padding: 30px 20px;\n}\n\n.heroTitle {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  overflow: visible;\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n\n.heroTitle {\n  font-size: 1.5rem;\n  font-weight: 400;\n  margin-bottom: 10px;\n  line-height: 1.5;\n}\n\n.buttonsContainer {\n  display: flex;\n  justify-content: center;\n  gap: 32px;\n  position: relative;\n  z-index: 2;\n}\n\n.heroButton {\n  margin: 0;  \n}\n\n.learnMore {\n  display: flex;\n  align-items: center;\n  color: white;\n  text-decoration: none;\n}\n\n.learnMoreButton {\n  margin-right: 5px;\n}\n\n.icon {\n  font-size: 18px;\n}\n\n@media (max-width: 768px) {\n  .gradientText {\n    font-size: 10rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .gradientText {\n    font-size: 6rem;\n  }\n}\n\n.heroWrap::before {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 40%;  \n  background: linear-gradient(to bottom, transparent, rgba(4, 4, 4, 1)); \n  z-index: 1;\n  pointer-events: none;\n}\n\n.heroWrap::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 0;  \n}\n\n.hero, .buttonsContainer {\n  position: relative;\n  z-index: 2;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fonts-loaded": `Hero_fonts-loaded__Anspl`,
	"gradientText": `Hero_gradientText__R1heV`,
	"heroSection": `Hero_heroSection__T2p92`,
	"heroWrap": `Hero_heroWrap__HEldU`,
	"backgroundVideo": `Hero_backgroundVideo__yrEow`,
	"hero": `Hero_hero__II8BZ`,
	"heroTitle": `Hero_heroTitle__wx3+G`,
	"buttonsContainer": `Hero_buttonsContainer__w9d7N`,
	"heroButton": `Hero_heroButton__q3Zvu`,
	"learnMore": `Hero_learnMore__FUrNz`,
	"learnMoreButton": `Hero_learnMoreButton__SK8eT`,
	"icon": `Hero_icon__jyGut`
};
export default ___CSS_LOADER_EXPORT___;
